import { Location } from './common.model'

export type User = {
  Id: string;
  Disabled?: boolean;
  Permissions?: string[];
  Profile?: {
    Name?: string;
    Addresses?: Location[];
    ImageUrl?: string;
  };
  Identity?: {
    SignInProvider?: string;
    Email?: string;
    PhoneNumber?: string;
    EmailVerified?: boolean;
  },
  Balance?: number;
  AvailableRewards?: any[]
}

export class UserLoyaltyResult {
  MainCredit: {
    Credit: number;
    PercentagePerTransaction: number;
    MaxCreditPerTransaction: number;
    _usable: number;
  };
  BusinessCredit: {
    Credit: number;
    PercentagePerTransaction: number;
    MaxCreditPerTransaction: number;
    _usable: number;
  };
  Balance: number;
}